module.exports = __webpack_public_path__ + "img/egypt_post.940c42cc.png";